import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import TitleFrom from '../../../../components/common/TitleFrom';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import { TrialSubscriptionSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportTrialSubscription, sortTrialSubscription } from '../../constants';
import { getTrialSubscription, getAllTrialSubscription } from '../../actions';
import { makeGetListTrialSubscription, makeGetListAllTrialSubscription } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelTrialSubscription';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfTrialSubscription';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class TrialSubscription extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listTrialSubscription: [],
    emails: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listTrialSubscription: props.listTrialSubscription,
      totalCount: getPageTotalCount({ ...state, items: props.listTrialSubscription }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetTrialSubscriptionReport },
    } = this.props;
    if (modeGetTrialSubscriptionReport) {
      this.doGetListTrialSubscription();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListTrialSubscription();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListTrialSubscription());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListTrialSubscription());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListTrialSubscription();
    });
  };

  doGetListTrialSubscription = () => {
    const { filter, page, size, sorted } = this.state;
    const { getTrialSubscription } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortTrialSubscription[sorted.sortCol]
          ? sortTrialSubscription[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getTrialSubscription(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistTrialSubscription = cb => {
    const { filter, sorted } = this.state;
    const { getAllTrialSubscription } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortTrialSubscription[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllTrialSubscription(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistTrialSubscription(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllTrialSubscription, t } = this.props;
        convertJson2Pdf({
          data: listAllTrialSubscription,
          t,
          title: t('reportPage:sidebar.trialSubscription').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.trialSubscription')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistTrialSubscription(() => {
      const { listAllTrialSubscription, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_TRIAL_SUBSCRIPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.trialSubscription')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.trialSubscription')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllTrialSubscription,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              accountType: 'accountType',
              trialTermUnit: 'trialTermUnit',
              trialType: 'trialTypes',
              trialLevel: 'trialLevel',
              initialTermUnit: 'initialTermUnit',
              renewalTermUnit: 'initialTermUnit',
              status: 'subscriptionStatus',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllTrialSubscription,
          t,
          title: t('reportPage:sidebar.trialSubscription').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.trialSubscription')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.trialSubscription')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('TRIAL_SUBSCRIPTION_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportTrialSubscription,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listTrialSubscription,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllTrialSubscription,
      t,
      permissions: { modeGetTrialSubscriptionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetTrialSubscriptionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.trialSubscription') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.trialSubscription')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <TrialSubscriptionSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.trialSubscription').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllTrialSubscription,
                          t,
                          title: t('reportPage:sidebar.trialSubscription').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.trialSubscription')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listTrialSubscription}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listTrialSubscription && listTrialSubscription.length ? listTrialSubscription : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

TrialSubscription.propTypes = {
  getTrialSubscription: PropTypes.func,
  getAllTrialSubscription: PropTypes.func,
  listAllTrialSubscription: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

TrialSubscription.defaultProps = {
  getTrialSubscription: () => {},
  getAllTrialSubscription: () => {},
  listAllTrialSubscription: [],
};

const mapStateToProps = createStructuredSelector({
  listTrialSubscription: makeGetListTrialSubscription() || [],
  listAllTrialSubscription: makeGetListAllTrialSubscription() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getTrialSubscription,
    getAllTrialSubscription,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(TrialSubscription)
);
